<template>
  <div class="sdui-list">
    <div v-if="hasHeadline" class="sdui-list__headline justify-content-between d-flex align-items-end">
      <slot name="title">
        <h2 v-if="title"
            :id="`sdui-list-heading-${listId}`"
            class="mb-2 h3"
            :class="{ smaller: link || $hasSlotContent($slots.link) }"
            data-cy="title"
        >{{ title }}</h2>
      </slot>
      <slot v-if="link || $hasSlotContent($slots.link)" name="link">
        <b-button variant="link"
                  class="pr-0 ml-auto"
                  @click="$emit('action-click')"
        >
          {{ link }}
        </b-button>
      </slot>
    </div>

    <component
      :is="isOrdered ? 'ol' : 'ul'"
      v-if="$hasSlotContent($slots.default)"
      class="list-unstyled mb-0 sdui-list__list"
      data-test="sdui-list"
      role="list"
      :aria-labelledby="title ? `sdui-list-heading-${listId}` : undefined"
    >
      <slot />
    </component>
  </div>
</template>

<script>
export default {
  name: 'SList',
  props: {
    title: {
      type: String,
      default: '',
    },

    link: {
      type: String,
      default: '',
    },

    isOrdered: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      listId: this.$uuid()
    }
  },

  // needed for the sdui-list-item component to be wrapped around in a li-tag, when using inside this sdui-list
  provide() {
    return {
      isUsedInSduiList: true,
      listId: this.listId
    }
  },

  computed: {
    hasHeadline() {
      const hasLinkSlot = this.$hasSlotContent(this.$slots.link)
      const hasTitleSlot = this.$hasSlotContent(this.$slots.title)

      return this.link || hasLinkSlot || this.title || hasTitleSlot
    },
  },

  emits: ['action-click'],
}
</script>

<style scoped lang="scss">
.sdui-list + .sdui-list {
  margin-top: 32px;
}

.sdui-list__list {
  box-shadow: $sdui-shadow;
  border-radius: 8px;
  border: 1px solid $color-gray-100;
}

.sdui-list__list :deep(.sdui-list-item) {
  border-top: initial;
  border-right: initial;
  border-left: initial;
  border-radius: 0;
  box-shadow: initial;
}

.sdui-list__list :deep(li:first-child .sdui-list-item) {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.sdui-list__list :deep(li:last-child .sdui-list-item) {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  border-bottom: initial;
}
</style>
